import { hooks } from '@febos-io/design';

import meta from '../../package.json';

export function useTranslation() {
  return hooks.useTranslation(meta.name);
}

export default useTranslation;
